import {
  Checkbox,
  Close,
  Link,
  Modal,
  ModalContent,
  ModalHeader,
  ModalHeaderActions,
  TransparentBackIconButton,
  Typography,
} from 'common-ui-components';
import PropTypes from 'prop-types';
import { useState } from 'react';

const Terms = ({ onChange, value, name, text }) => {
  const [isOpen, setIsOpen] = useState(false);
  const handleClose = () => setIsOpen(false);

  return (
    <div className='terms'>
      <Modal open={isOpen} onCloseRequest={handleClose}>
        <ModalHeader>
          <ModalHeaderActions>
            <TransparentBackIconButton onClick={handleClose}>
              <Close size={27} />
            </TransparentBackIconButton>
          </ModalHeaderActions>
        </ModalHeader>

        <ModalContent>
          <div
            className='terms-content'
            dangerouslySetInnerHTML={{ __html: text.content }}
          />
        </ModalContent>
      </Modal>
      <div className='terms-container'>
        <Checkbox value={value} name={name} checked={value} onChange={onChange} data-testid={name}>
          <Link
            onClick={(e) => {
              e.preventDefault();
              setIsOpen(true);
            }}
          >
            {text.title}
          </Link>
        </Checkbox>
      </div>
    </div>
  );
};

export default Terms;

Terms.propTypes = {
  onChange: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  value: PropTypes.bool.isRequired,
  text: PropTypes.object.isRequired,
};
